"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_ROLES = exports.USER_ROLE_LABELS = exports.ADMIN_ROLE = void 0;
exports.formatUserRole = formatUserRole;
exports.formatUserRoleFromUser = formatUserRoleFromUser;
var roles_1 = require("../utils/roles");
var ADMIN_ROLE = "client_administrator";
exports.ADMIN_ROLE = ADMIN_ROLE;
var USER_ROLES = ["system_administrator", "client_administrator", "manager", "staff", "pharmacist"];
exports.USER_ROLES = USER_ROLES;
var USER_ROLE_LABELS = {
    system_administrator: "System Administrator",
    client_administrator: "Client Administrator",
    manager: "Manager",
    staff: "Staff",
    pharmacist: "Pharmacist",
};
exports.USER_ROLE_LABELS = USER_ROLE_LABELS;
function formatResolvedRole(role) {
    var _a;
    return ((_a = USER_ROLE_LABELS[role]) !== null && _a !== void 0 ? _a : role
        .split("_")
        .filter(Boolean)
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
        .join(" "));
}
function formatUserRole(role) {
    return formatResolvedRole((0, roles_1.resolveUserRole)(role));
}
function formatUserRoleFromUser(user) {
    return formatResolvedRole((0, roles_1.resolveUserRole)(user));
}
